export default {
  "api.password.update.success": "Password updated successfully",
  "api.profile.update.error": "Error when updating:",
  "api.profile.update.success": "Profile updated",
  "common.boolean.false": "FALSE",
  "common.boolean.true": "TRUE",
  "common.cancel": "Cancel",
  "dashboard.activityLog.description": "Recent events from your project",
  "dashboard.activityLog.title": "Activity log",
  "dashboard.errorsChart.description": "4xx and 5xx responses",
  "dashboard.errorsChart.title": "Errors per day",
  "dashboard.quotas.bandwidth": "Bandwidth",
  "dashboard.quotas.database": "Database",
  "dashboard.quotas.description": "Usage of plan limits",
  "dashboard.quotas.edgeInvocations": "Edge invocations",
  "dashboard.quotas.storage": "Storage",
  "dashboard.quotas.title": "Quotas",
  "dashboard.recentUsers.column.email": "Email",
  "dashboard.recentUsers.column.joined": "Joined",
  "dashboard.recentUsers.column.provider": "Provider",
  "dashboard.recentUsers.column.status": "Status",
  "dashboard.recentUsers.description": "Latest sign-ups via auth providers",
  "dashboard.recentUsers.title": "Recent users",
  "dashboard.stats.activeUsers.hint": "vs last 7 days",
  "dashboard.stats.activeUsers.label": "Active users",
  "dashboard.stats.apiRequests.hint": "last 24 hours",
  "dashboard.stats.apiRequests.label": "API requests",
  "dashboard.stats.databaseSize.hint": "of 8 GB plan",
  "dashboard.stats.databaseSize.label": "Database size",
  "dashboard.stats.errorRate.hint": "last 24 hours",
  "dashboard.stats.errorRate.label": "Error rate",
  "dashboard.tablesOverview.column.rows": "Rows",
  "dashboard.tablesOverview.column.size": "Size",
  "dashboard.tablesOverview.column.table": "Table",
  "dashboard.tablesOverview.description": "Top tables by size in the public schema",
  "dashboard.tablesOverview.title": "Database tables",
  "dashboard.tablesOverview.viewAll": "View all",
  "dashboard.trafficChart.description": "Requests over the last 7 days",
  "dashboard.trafficChart.title": "API traffic",
  "error.boundary.description": "An unexpected error occurred. Try refreshing the page or contact support if the problem persists.",
  "error.boundary.refresh": "Refresh page",
  "error.boundary.retry": "Try again",
  "error.boundary.title": "Something went wrong",
  "form.field.email.invalid": "Invalid email address",
  "form.field.email.placeholder": "Enter email",
  "form.field.password.label": "Password",
  "form.field.password.min": "At least 6 characters",
  "form.field.password.placeholder": "******",
  "form.login.description": "Enter your login credentials to continue.",
  "form.login.title": "Log in",
  "form.submit.loading": "Sign in...",
  "form.submit.title": "Sign in",
  "page.dashboard.title": "Dashboard",
  "page.help.title": "Get Help",
  "page.login.overview.activity": "Realtime activity",
  "page.login.overview.growth": "Growth",
  "page.login.overview.live": "Live",
  "page.login.overview.requests": "Requests",
  "page.login.overview.title": "Project Overview",
  "page.login.overview.users": "Users",
  "page.notFound.back": "Back to last",
  "page.notFound.code": "404 error",
  "page.notFound.description": "The page you're looking for doesn't exist or has been moved. Check the URL or return to the dashboard.",
  "page.notFound.home": "Go home",
  "page.notFound.title": "Page not found",
  "page.products.placeholder": "Products page",
  "page.profile.about-app.description": "Information about the current version and build.",
  "page.profile.about-app.legal-information.copyright": "© {year} Lovable. All rights reserved.",
  "page.profile.about-app.legal-information.description": "Documents and links.",
  "page.profile.about-app.legal-information.privacy-policy": "Privacy policy",
  "page.profile.about-app.legal-information.terms-of-use": "Terms of use",
  "page.profile.about-app.legal-information.title": "Legal information",
  "page.profile.about-app.title": "About the application",
  "page.profile.avatar.fileTooLarge": "File size must be less than 2MB",
  "page.profile.avatar.hint": "PNG, JPG or WEBP. Max 2MB.",
  "page.profile.avatar.upload": "Upload",
  "page.profile.dangerZone.button": "Delete my account",
  "page.profile.dangerZone.confirmAction": "Yes, delete my account",
  "page.profile.dangerZone.confirmDescription": "This will permanently delete your account ({userId}…) and all associated data. This action cannot be undone.",
  "page.profile.dangerZone.confirmTitle": "Delete your account?",
  "page.profile.dangerZone.deleteError": "Failed to delete account.",
  "page.profile.dangerZone.deleteSuccess": "You've been signed out. Contact support to complete deletion.",
  "page.profile.dangerZone.deleting": "Deleting…",
  "page.profile.dangerZone.description": "All your data will be permanently deleted. This action cannot be undone.",
  "page.profile.dangerZone.title": "Delete account",
  "page.profile.general.email": "Email",
  "page.profile.general.firstName": "First Name",
  "page.profile.general.lastName": "Last Name",
  "page.profile.general.save": "Save",
  "page.profile.general.title": "General",
  "page.profile.profile.subTitle": "Personal information and contact details",
  "page.profile.profile.title": "Profile",
  "page.profile.security.changePassword": "Change password",
  "page.profile.security.changePasswordDescription": "Update your account password",
  "page.profile.security.confirmPassword": "Confirm password",
  "page.profile.security.newPassword": "New password",
  "page.profile.security.subTitle": "Account security actions and events",
  "page.profile.security.title": "Security",
  "page.profile.security.updatePassword": "Update password",
  "page.profile.sessions.description": "Devices currently signed in to your account.",
  "page.profile.sessions.signOutError": "Failed to sign out other sessions.",
  "page.profile.sessions.signOutOthers": "Sign out all other sessions",
  "page.profile.sessions.signOutSuccess": "Signed out of all other sessions.",
  "page.profile.sessions.signingOut": "Signing out…",
  "page.profile.sessions.title": "Active sessions",
  "page.profile.settings.dateFormat": "Date format",
  "page.profile.settings.dateFormatDescription": "How to display dates",
  "page.profile.settings.headerSticky": "Header sticky",
  "page.profile.settings.headerStickyDescription": "Change the header property to “Sticky”",
  "page.profile.settings.language": "Language",
  "page.profile.settings.language.en": "English",
  "page.profile.settings.language.ru": "Russian",
  "page.profile.settings.languageDescription": "Language",
  "page.profile.settings.sidebarCollapsible": "Sidebar Collapsible",
  "page.profile.settings.sidebarCollapsible.icon": "Icon",
  "page.profile.settings.sidebarCollapsible.none": "None",
  "page.profile.settings.sidebarCollapsible.offcanvas": "Offcanvas",
  "page.profile.settings.sidebarCollapsibleDescription": "Side menu collapse option",
  "page.profile.settings.sidebarVariant": "Sidebar Variant",
  "page.profile.settings.sidebarVariant.floating": "Floating",
  "page.profile.settings.sidebarVariant.inset": "Inset",
  "page.profile.settings.sidebarVariant.sidebar": "Sidebar",
  "page.profile.settings.sidebarVariantDescription": "Side menu display option",
  "page.profile.settings.subTitle": "Configure the language and theme of the interface.",
  "page.profile.settings.theme": "Design theme",
  "page.profile.settings.themeField": "Select a color theme",
  "page.profile.settings.title": "Settings",
  "page.profile.signOut": "Sign out",
  "page.storage.buckets.description": "Select to browse",
  "page.storage.buckets.private": "private",
  "page.storage.buckets.public": "public",
  "page.storage.buckets.title": "Buckets",
  "page.storage.createBucket.description": "Buckets store files. Configure access and limits below.",
  "page.storage.createBucket.mimeHint": "Comma-separated. Wildcards like image/* are allowed.",
  "page.storage.createBucket.mimeLabel": "Allowed MIME types",
  "page.storage.createBucket.mimePlaceholder": "image/png, image/jpeg, application/pdf",
  "page.storage.createBucket.nameHint": "Bucket names must be lowercase and contain no spaces.",
  "page.storage.createBucket.nameLabel": "Name of bucket",
  "page.storage.createBucket.namePlaceholder": "e.g. avatars",
  "page.storage.createBucket.publicHint": "Anyone with the URL can view files. RLS still applies to writes.",
  "page.storage.createBucket.publicLabel": "Public bucket",
  "page.storage.createBucket.restrictHint": "Limit which MIME types can be uploaded.",
  "page.storage.createBucket.restrictLabel": "Restrict file types",
  "page.storage.createBucket.sizeHint": "Leave empty for no limit.",
  "page.storage.createBucket.sizeLabel": "File size limit",
  "page.storage.createBucket.sizePlaceholder": "e.g. 50",
  "page.storage.createBucket.submit": "Create bucket",
  "page.storage.createBucket.title": "Create a new bucket",
  "page.storage.empty.action": "New bucket",
  "page.storage.empty.description": "Buckets are containers for your files. Create your first bucket to start uploading and managing files.",
  "page.storage.empty.title": "No buckets yet",
  "page.storage.files.column.modified": "Modified",
  "page.storage.files.column.name": "Name",
  "page.storage.files.column.size": "Size",
  "page.storage.files.count": "{count} files",
  "page.storage.files.empty": "No files in this bucket",
  "page.storage.files.filter": "Filter",
  "page.storage.files.searchPlaceholder": "Search files…",
  "page.storage.files.upload": "Upload",
  "page.storage.stats.bandwidth": "Bandwidth (24h)",
  "page.storage.stats.bandwidthPlan": "of 250 GB plan",
  "page.storage.stats.buckets": "Buckets",
  "page.storage.stats.bucketsBreakdown": "{publicCount} public · {privateCount} private",
  "page.storage.stats.liveFromSupabase": "Live from Supabase",
  "page.storage.stats.totalFiles": "Total files",
  "page.storage.stats.totalStorage": "Total storage",
  "page.storage.title": "Storage",
  "page.tables.index.description": "Select a table from the sidebar to view and manage records.",
  "page.users.description": "Manage accounts and access.",
  "page.users.empty": "No users yet.",
  "page.users.title": "Users",
  "project.name": "{name} Panel",
  "project.rights": "© {date} {name} Panel. All rights reserved",
  "sidebar.tables.label": "Tables",
  "table.action.delete": "Delete",
  "table.action.edit": "Edit",
  "table.create": "Create",
  "table.creating": "Creating",
  "table.creating_description": "Adding a record to the {resource} table",
  "table.editing": "Editing",
  "table.editing_description": "Editing record {id} from the {resource} table",
  "table.empty.action": "Add record",
  "table.empty.description": "Add your first record to get started",
  "table.empty.title": "No records found",
  "table.noSearchResults": "No results match your search.",
  "table.pagination.page": "Page {current} of {total}",
  "table.pagination.rowsPerPage": "Rows per page",
  "table.pagination.showing": "Showing {from} - {to} of {total}",
  "table.search.fieldFallback": "field",
  "table.search.fieldPlaceholder": "Field",
  "table.search.placeholder": "Search by {field}...",
  "table.selectAll": "Select all",
  "table.selectRow": "Select row",
  "table.selectedCount": "{count} selected",
  "validation.password.match": "Passwords do not match",
  "validation.password.min": "Minimum 8 characters"
};
